import { useEffect, useRef, useState } from "react";
import { devLog } from "../../../utils/devLog";
import api, { fetchCheckoutDetails } from "../../../api/api";
import { useCheckout } from "../../../context/CheckoutContext";
import { formatFrequencyUnit } from "../../../utils/commonUtils";
import PaymentProcessingModal from "../../modal/PaymentProcessingModal";
import TransactionStatusModal from "../../modal/TransactionStatusModal";
import { toast } from "react-toastify";
// import "./PaysafePaymentForm.css"; // Optional if you want to move styles here

const PaysafePaymentForm = ({ 
                formData, 
                itemDetails, 
                billingPlatformId,
                routingEntries,
                planId,
                platformItemDetails,
                checkoutPageConfDto: checkoutPageConfDtoProp,
            }) => {
  const scriptRef = useRef(null);
  const instanceRef = useRef(null);
  const [formValid, setFormValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const { triggerPaymentMethodEvent, resetTrigger, clientIp, clientCountry, paymentMethodName, platformName, estimatedOrder } = useCheckout();
  const [gatewayConnection, setGatewayConnection] = useState("");
  const [showProcessingModal, setProcessingModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [transactionStatus, setTransactionStatus] = useState(""); 
  const [checkoutPageConfDto, setCheckoutPageConfDto] = useState(
    checkoutPageConfDtoProp || null
  );

  useEffect(() => {
    if (triggerPaymentMethodEvent) {
      if(platformName =="paysafe" && paymentMethodName == "card"){
        handlePayNow();
        devLog("Paysafe payment method triggered");
        resetTrigger();
      }
    }
  }, [triggerPaymentMethodEvent]);

  const fetchDetails = async (id, planId) => {
    try {
      const data = await fetchCheckoutDetails(id, planId);
      if (data?.checkoutPageConfDto) {
        setCheckoutPageConfDto(data.checkoutPageConfDto);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
    }
  };

  useEffect(() => {
    if (checkoutPageConfDtoProp) {
      setCheckoutPageConfDto(checkoutPageConfDtoProp);
      return;
    }
    if (billingPlatformId && planId) {
      fetchDetails(billingPlatformId, planId);
    }
  }, [billingPlatformId, planId, checkoutPageConfDtoProp]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://hosted.paysafe.com/js/v1/latest/paysafe.min.js";
    script.async = true;

    //log all form data used

    script.onload = () => {
      const API_KEY = "T1QtMTExNjM4MDpCLXFhMi0wLTY3ZDZkODFkLTAtMzAyZDAyMTQ3YmNjMWUyNGVhZDI0NTRkNDE0Y2FmODJkNGQxMzk3NmIyZmU1ZGRiMDIxNTAwOGNiNzE1NjZhMDZmMjZlMDBkZTI2YzAyZGIwN2VjZGVkOTlhNzAzMw==";

      const options = {
        currencyCode: "USD",
        environment: "TEST",
        fields: {
          cardNumber: {
            selector: "#cardNumber",
            placeholder: "Card Number",
          },
          expiryDate: {
            selector: "#expiryDate",
            placeholder: "MM/YY",
          },
          cvv: {
            selector: "#cvv",
            placeholder: "CVV",
            optional: false,
          },
        },
      };

      window.paysafe.fields
        .setup(API_KEY, options)
        .then((instance) => {
          instanceRef.current = instance;
          return instance.show();
        })
        .catch((error) => {
          alert("Paysafe setup failed: " + JSON.stringify(error));
        });
    };

    scriptRef.current = script;
    document.body.appendChild(script);

    return () => {
      if (scriptRef.current) {
        document.body.removeChild(scriptRef.current);
      }
    };
  }, []);

  const filterRoutingEntries = (entries, paymentMethod, platform) => {
    return entries.filter(
      (entry) =>
        entry.paymentMethod === paymentMethod && entry.platform === platform
    );
  };


  const handlePayNow = async () => {
    setProcessingModal(true);
    if (!instanceRef.current) return;

    setLoading(true);
    setFormValid(true);

    const tokenizationOptions = {
      amount: itemDetails?.price ? parseFloat(itemDetails.price) * 100 : 1000,
      currencyCode: itemDetails?.currencyCode || "USD",
      transactionType: "PAYMENT",
      paymentType: "CARD",
      merchantRefNum: "ref-" + new Date().getTime(),
      customerDetails: {
        holderName: `${formData?.firstName || ''} ${formData?.lastName || ''}`.trim(),
      },
      billingDetails: {
        firstName: formData?.firstName || "",
        lastName: formData?.lastName || "",
        country: formData?.billingAddress?.country || clientCountry || "US",
        zip: formData?.billingAddress?.zipCode || "90210",
        street: formData?.billingAddress?.street || "",
        street2: formData?.billingAddress?.addressLine2 || "",
        city: formData?.billingAddress?.city || "",
        state: formData?.billingAddress?.state || "",
      },
      threeDS: {
        profile: {
          email: formData?.email || "",
          phone: formData?.phone || "023456789",
          firstName: formData?.firstName || "",
          lastName: formData?.lastName || "",
        },
        useThreeDSecureVersion2: true,
        // authenticationPurpose: "PAYMENT_TRANSACTION",
        merchantUrl: "https://www.google.com",
        deviceChannel: "BROWSER",
      },
    };

    try {
      const routingEntry = filterRoutingEntries(
        routingEntries,
        "card",
        "paysafe"
      );

      if (routingEntry.length === 0) {
        // setError("UPI payment method is not available for this transaction.");
        return;
      }
      
      // devLog("The filter routing entry ", routingEntry[0]);
      const gateway_connection = await fetchGatewayConnection(routingEntry[0]);
      // devLog("The gatewayCconnection ", gatewayConnection);

      // devLog("The tokenization options are ", tokenizationOptions);
      const result = await instanceRef.current.tokenize(tokenizationOptions);

      const data = {
        paymentData: {
          gatewayConnectionId: gateway_connection?.id,
          gatewayName: gateway_connection?.platform,
          paymentMethod: "card",
          amount: estimatedOrder?.futureInvoiceAmountDue ? 
            Math.round(estimatedOrder.futureInvoiceAmountDue * 100) : 
            (itemDetails?.price ? parseFloat(itemDetails.price) * 100 : 1000),
          currency: estimatedOrder?.currency || itemDetails?.currencyCode || "USD",
          transactionId: "",
          additionalData: {
            paymentHandleToken: result?.token
          }
        },
        customerData: {
          firstName: formData?.firstName,
          lastName:  formData?.lastName,
          email: formData?.email,
          ip:  clientIp || "192.0.126.111",
          billingAddress: {
            country: formData?.billingAddress?.country || clientCountry || "US",
            zipCode: formData?.billingAddress?.zipCode || "90210",
            street: formData?.billingAddress?.street || "",
            city: formData?.billingAddress?.city || "",
            state: formData?.billingAddress?.state || "",
          },
          shippingAddress: {
          }
        },
        billingData: {
          planId: planId,
          billingPlatformId: billingPlatformId,
          billingPlatformName: itemDetails?.billingPlatformName,
          frequency: formatFrequencyUnit(itemDetails?.period),
        }
      };
      

      const response = await processTransaction(data);
      setTransactionStatus("success"); // or "failed" based on response
      setShowStatusModal(true);
      // alert("✅ Thank you for subscribing!");
      // window.location.reload();
    } catch (error) {
      console.error("Tokenization or Payment failed:", error);
      alert("❌ Invalid card or payment error: " + JSON.stringify(error));
      setFormValid(false);
    } finally {
      setLoading(false);
    }
  };

  const processTransaction = async(data) => {
    try {
      // devLog("The billing transaciton  ", billingPlatformId);
      const response = await api.post(`/api/checkout/v1/${billingPlatformId}/processPayment`, data);
      if (response.status === 200) {
        // alert(itemDetails?.billingPlatformName + ' Subscription created created successfully!');
        //TODO close the processing modal show Transaction status modal
        return response?.data;
      } else {
        alert("Something went wrong while creating " + itemDetails?.billingPlatformName + " Subscription .");
      }
      setProcessingModal(false);
    } catch (error) {
      console.error("Customer Error:", error);
      alert(`${itemDetails?.billingPlatformName} subscription failed: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
      setProcessingModal(false);
    }
  }

  const fetchGatewayConnection = async (routing) => {
    try{
      const response = await api.get(`/api/checkout/v1/${routing?.id}/gatewayConnection`);
      if (response.status === 200) {
        // devLog("Gateway connection fetched successfully:", response);
        setGatewayConnection(response.data);        
        return response?.data;
      } else {
        throw new Error("Failed to fetch gateway connection");
      }

    }catch (error) {
      console.error("Error fetching gateway connection:", error);
    }

  }

  return (
    <div className="payment-container">

      <label className="input-label">Card Number</label>
      <div id="cardNumber" className="input-field" />

      <label className="input-label">Expiry Date</label>
      <div id="expiryDate" className="input-field" />

      <label className="input-label">CVV</label>
      <div id="cvv" className="input-field" />

      {/* {!formValid && <div className="error-message">Please enter valid card details.</div>} */}
      {loading && (
          <div className="loader-overlay">
            <div className="spinner" />
          </div>
        )}


      {/* <button onClick={handlePayNow} disabled={loading} className="pay-now-button">
        {loading ? "Processing..." : "Pay Now"}
      </button> */}

      <style jsx>{`
        .payment-container {
        position: relative;
          width: 100%;
          padding: 20px;
          border-radius: 12px;
          background-color: #f9f9f9;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
          font-family: Arial, sans-serif;
        }

        .input-label {
          font-size: 14px;
          margin-top: 12px;
          margin-bottom: 4px;
          display: block;
          color: #333;
        }

        .input-field {
          border: 1px solid #ccc;
          border-radius: 6px;
          padding: 10px;
          background-color: #fff;
          height: 48px
        }

        .pay-now-button {
          margin-top: 20px;
          padding: 10px 16px;
          font-size: 14px;
          border: none;
          border-radius: 6px;
          background-color: #0070f3;
          color: white;
          cursor: pointer;
        }

        .pay-now-button:disabled {
          background-color: #ccc;
        }

        .error-message {
          margin-top: 10px;
          color: red;
          font-size: 13px;
        }
          .loader-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        }

      .spinner {
        border: 6px solid #f3f3f3;
        border-top: 6px solid #0070f3;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      `}</style>
      <PaymentProcessingModal 
        show={showProcessingModal}
        setShow={setProcessingModal}
      />

      <TransactionStatusModal
        show={showStatusModal}
        setShow={setShowStatusModal}
        status={transactionStatus}
        redirectUrl={checkoutPageConfDto?.checkoutRedirectUrl}
   />
    </div>
  );
};

export default PaysafePaymentForm;


// // Send a single request with all the data
// const response = await createCombinedRequest(requestData);


